import { Component } from "react";

import LinesEllipsis from "react-lines-ellipsis";
import DataTable from "components/DigiHapi/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import BookingCard from "examples/Cards/BookingCard";

// DigiHapi components
import Activity from "components/DigiHapi/Activity";
import ConfirmDialog from "components/DigiHapi/ConfirmDialog";
import MDWizard from "components/DigiHapi/MDWizard";
import Notification from "components/DigiHapi/Notification";
import PagePagination from "components/DigiHapi/PagePagination";

import {
	fetchPayGoodDeal,
	fetchAddGoodDeal,
	fetchDeleteGoodDeal,
	fetchGetGoodDealDetails,
	fetchGetGoodDealChannels,
	fetchGetOwnGoodDeal,
	fetchUpdateGoodDeal,
	fetchPublishGoodDeal,
	fetchModeratingAccept,
	fetchModeratingRefuse
} from "actions/gooddeal";
import {
	RESET_GOODDEAL,
	SET_GOODDEAL_SORTED,
	EDITING,
	PUBLISHED,
	MODERATING,
	REFUSED,
	ROLE_WEBMASTER,
	SET_GOODDEALS_ORGANIZATION_SCOPE
} from "actions/types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Step7 from "./Step7";
import Step8 from "./Step8";
const { REACT_APP_DEEPLINK_URL } = process.env;

// Public app URL of a good deal
const getGoodDealUrl = (id, lang) =>
	`${
		REACT_APP_DEEPLINK_URL
			? REACT_APP_DEEPLINK_URL
			: "https://app.ocamping.digihapi.com"
	}/annonce?id=${id}${lang ? `&lang=${lang}` : ""}`;

class GoodDealsWizard extends Component {
	fetchAddGoodDeal = () => {
		const {
			fetchAddGoodDeal,
			files,
			categoryId,
			description,
			phone,
			email,
			openingTime,
			price,
			address,
			zipCode,
			city,
			loc,
			webSiteUrl,
			fbUrl,
			title,
			promotion,
			lang,
			templateId,
			choices,
			activityDescription,
			activityPostDescription,
			customUri
		} = this.props;

		fetchAddGoodDeal({
			files,
			categoryId,
			description,
			phone,
			email,
			openingTime,
			price,
			address,
			zipCode,
			city,
			loc,
			webSiteUrl,
			fbUrl,
			title,
			promotion,
			lang,
			templateId: templateId ? templateId : null,
			choices,
			activityDescription,
			activityPostDescription,
			customUri
		});
	};

	fetchUpdateGoodDeal = () => {
		const {
			// fetchPayGoodDeal,
			// token,
			fetchUpdateGoodDeal,
			_id,
			files,
			categoryId,
			description,
			phone,
			email,
			openingTime,
			price,
			address,
			zipCode,
			city,
			loc,
			webSiteUrl,
			fbUrl,
			title,
			promotion,
			lang,
			photoUri,
			templateId,
			choices,
			activityDescription,
			activityPostDescription,
			customUri
		} = this.props;

		// fetchPayGoodDeal({ token });
		fetchUpdateGoodDeal({
			_id,
			files,
			categoryId,
			description,
			phone,
			email,
			openingTime,
			price,
			address,
			zipCode,
			city,
			loc,
			webSiteUrl,
			fbUrl,
			title,
			promotion,
			lang,
			photoUri,
			templateId: templateId ? templateId : null,
			choices,
			activityDescription,
			activityPostDescription,
			customUri
		});
	};

	render() {
		const { update, isFetching, onClose } = this.props;
		return (
			<>
				<MDWizard
					onClose={onClose}
					isFetching={isFetching}
					validate
					steps={[
						{
							stepName: "Illustration",
							stepComponent: Step1,
							stepId: "picture"
						},
						{
							stepName: "Français",
							stepComponent: Step2,
							stepId: "french"
						},
						{
							stepName: "Anglais",
							stepComponent: Step3,
							stepId: "english"
						},
						{
							stepName: "Informations",
							stepComponent: Step4,
							stepId: "infos"
						},
						{
							stepName: "Localisation",
							stepComponent: Step5,
							stepId: "gooddeal"
						}
						// {
						//   stepName: "Panier",
						//   stepComponent: ComponentsStep7.Step7,
						//   stepId: "payment"
						// }
					]}
					title={update ? "Mise à jour d'une annonce" : "Ajout d'une annonce"}
					finishButtonClick={
						update ? this.fetchUpdateGoodDeal : this.fetchAddGoodDeal
					}
					finishButtonText={update ? "Modifier" : "Ajouter"}
				/>
			</>
		);
	}
}

// One publication step per app, for the communities of the given type
const PUBLISH_STEPS = [
	{
		stepName: "HapiCity",
		stepComponent: Step6,
		stepId: "hapicity_channels",
		communityType: "City"
	},
	{
		stepName: "O’Camping",
		stepComponent: Step7,
		stepId: "ocamping_channels",
		communityType: "Campsite"
	},
	{
		stepName: "HapiColibri",
		stepComponent: Step8,
		stepId: "hapicolibri_channels",
		communityType: "Neighborhood"
	}
];

// Good deals of an organization (managed by its administrator or by the
// webmaster acting as such) are only published in the app of the organization
export const getPublishSteps = (organizationScope, organization) => {
	if (!organizationScope) {
		return PUBLISH_STEPS;
	}
	const steps = PUBLISH_STEPS.filter(
		({ communityType }) =>
			communityType === organization?.organizationCommunityType
	);
	return steps.length ? steps : PUBLISH_STEPS;
};

class PublishWizard extends Component {
	publishGoodDeal = () => {
		const { fetchPublishGoodDeal, _id: goodDealId, channelsIds } = this.props;
		fetchPublishGoodDeal(goodDealId, channelsIds);
	};

	render() {
		const { isFetching, onClose, title, scopedToOrganization, organization } =
			this.props;
		return (
			<>
				<MDWizard
					onClose={onClose}
					isFetching={isFetching}
					validate
					steps={getPublishSteps(scopedToOrganization, organization)}
					title={"Mise en ligne de l'annonce"}
					subtitle={title ?? ""}
					finishButtonClick={this.publishGoodDeal}
					finishButtonText={"Publier"}
				/>
			</>
		);
	}
}

class GoodDealsPage extends Component {
	state = {
		br: false,
		color: "info",
		message: null,
		wizard: null,
		goodDealToDelete: null,
		modeTable: false
	};

	componentDidMount() {
		// Must be set before the first request (see the organizationScoped actions)
		this.props.dispatch({
			type: SET_GOODDEALS_ORGANIZATION_SCOPE,
			value: !!this.props.organizationScope
		});
		this.props.fetchGetOwnGoodDeal();
	}

	componentWillUnmount() {
		this.props.dispatch({
			type: SET_GOODDEALS_ORGANIZATION_SCOPE,
			value: false
		});
	}

	componentDidUpdate(prevProps, prevState) {
		const { snackErrorMsg, snackInfoMsg, newWizard, page, limit, sorted } =
			this.props;

		if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
			this.autoCloseMessage();
		}

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				wizard: null
			});
			this.props.fetchGetOwnGoodDeal(page, limit, sorted);
			this.autoCloseMessage();
		}

		if (newWizard && prevProps.newWizard !== newWizard) {
			if (newWizard === "publish") {
				this.addPublishWizard();
			} else {
				this.addWizard(newWizard === "update");
			}
		}
	}

	hideAlert = () => {
		this.setState({
			br: false
		});
	};

	autoCloseMessage = () => {
		const { snackErrorMsg, snackInfoMsg } = this.props;

		this.setState({
			br: true,
			message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
			color: snackInfoMsg ? "info" : "danger"
		});

		if (snackInfoMsg) {
			setTimeout(this.hideAlert, 5000);
		}
	};

	onClose = () => {
		this.setState({
			wizard: null
		});
		this.props.dispatch({
			type: RESET_GOODDEAL
		});
	};

	// Wrap the wizard in a DOM element with a ref to scroll to it
	showWizard = wizard => {
		this.setState({
			wizard: (
				<Grid
					item
					xs={12}
					ref={elt => {
						this.wizardRef = elt;
					}}
				>
					{wizard}
				</Grid>
			)
		});
	};

	addPublishWizard = () => {
		this.showWizard(<ConnectedPublishWizard onClose={this.onClose} />);
	};

	addWizard = (update = true) => {
		this.showWizard(
			<ConnectedGoodDealsWizard update={update} onClose={this.onClose} />
		);
	};

	editGoodDeal = id => {
		this.props.fetchGetGoodDealDetails(id);
	};

	editGoodDealChannels = id => {
		this.props.fetchGetGoodDealChannels(id);
	};

	deleteGoodDeal = id => {
		this.props.fetchDeleteGoodDeal(id);
	};

	// Actions available on a good deal, depending on its status and the user role
	getActions = status => {
		const { user } = this.props;
		const actions = [];

		if (status === EDITING || status === PUBLISHED) {
			actions.push({
				color: "success",
				icon: "send",
				onClick: this.editGoodDealChannels,
				tooltip: "Publier"
			});
		}
		if (status === MODERATING && user.role === ROLE_WEBMASTER) {
			actions.push({
				color: "error",
				icon: "error",
				onClick: this.refuse,
				tooltip: "Rejeter"
			});
		}
		if (status === MODERATING && user.role === ROLE_WEBMASTER) {
			actions.push({
				color: "success",
				icon: "check_circle",
				onClick: this.accept,
				tooltip: "Accepter"
			});
		}
		if (status !== MODERATING || user.role === ROLE_WEBMASTER) {
			actions.push({
				color: "info",
				icon: "edit",
				onClick: this.editGoodDeal,
				tooltip: "Modifier"
			});
		}
		actions.push({
			color: "error",
			icon: "delete",
			onClick: this.delete,
			tooltip: "Supprimer"
		});
		return actions;
	};

	renderActionButton = (action, id, variant = "text") => (
		<Tooltip key={action.tooltip} title={action.tooltip} placement="bottom">
			<span>
				<MDButton
					variant={variant}
					color={action.color}
					size="small"
					iconOnly
					circular={variant !== "text"}
					disabled={!!this.state.wizard && !action.href}
					onClick={() => action.onClick(id)}
					href={action.href}
					target={action.href ? "_blank" : undefined}
					sx={{ mx: 0.25 }}
				>
					<Icon>{action.icon}</Icon>
				</MDButton>
			</span>
		</Tooltip>
	);

	getCampsitesNames = communitiesIds => {
		let campsiteNames = "";
		for (let index = 0; index < communitiesIds.length; index++) {
			const communityId = communitiesIds[index];
			if (index) {
				campsiteNames += ", " + this.props.campsites[communityId].name;
			} else {
				campsiteNames += this.props.campsites[communityId].name;
			}
		}

		return campsiteNames;
	};

	get2Chars = param => {
		return ("" + param).length === 1 ? "0" + param : param;
	};

	formatDate = (d, withTime = true) => {
		const date = new Date(d);
		return `${this.get2Chars(date.getDate())}/${this.get2Chars(
			date.getMonth() + 1
		)}/${date.getFullYear()} ${
			withTime
				? this.get2Chars(date.getHours()) +
				  ":" +
				  this.get2Chars(date.getMinutes())
				: ""
		}`;
	};

	getStrState = status => {
		switch (status) {
			case MODERATING:
				return "En cours de modération";

			case PUBLISHED:
				return "Publiée";

			case REFUSED:
				return "Rejeté";

			default:
				return "Brouillon";
		}
	};

	getOwnGoodDealsData = () => {
		const { goodDeals, goodDealsCategories } = this.props;

		const result = goodDeals.map(
			({ _id, dateUpdated, title, categoryId, validationDate, status }) => {
				return {
					dateUpdated: this.formatDate(dateUpdated),
					title,
					status: this.getStrState(status),
					category: goodDealsCategories[categoryId].name,
					validationDate: this.formatDate(validationDate, false),
					actions: (
						<MDBox display="flex" justifyContent="flex-end">
							{this.getActions(status).map(action =>
								this.renderActionButton(action, _id, "gradient")
							)}
						</MDBox>
					)
				};
			}
		);
		return result;
	};

	accept = id => {
		this.props.fetchModeratingAccept(id);
	};

	refuse = id => {
		this.props.fetchModeratingRefuse(id);
	};

	renderStatus = goodDeal => {
		let status = null;
		switch (goodDeal.status) {
			case EDITING:
				status = { color: "info", icon: "edit", text: "Brouillon" };
				break;
			case MODERATING:
				status = {
					color: "warning",
					icon: "remove_red_eye",
					text: "En cours de modération"
				};
				break;
			case REFUSED:
				status = { color: "error", icon: "report_problem", text: "Rejetée" };
				break;
			case PUBLISHED:
				status = {
					color:
						new Date(goodDeal.validationDate).getTime() > Date.now()
							? "success"
							: "error",
					icon: "update",
					text: this.formatDate(goodDeal.validationDate),
					tooltip: "Date d'expiration"
				};
				break;
			default:
				return null;
		}
		const content = (
			<MDBox display="flex" alignItems="center" color={status.color}>
				<Icon color="inherit" sx={{ mr: 0.5 }}>
					{status.icon}
				</Icon>
				<MDTypography variant="button" color={status.color}>
					{status.text}
				</MDTypography>
			</MDBox>
		);
		return status.tooltip ? (
			<Tooltip title={status.tooltip} placement="bottom">
				{content}
			</Tooltip>
		) : (
			content
		);
	};

	renderGoodDeals = () => {
		const { goodDeals, goodDealsCategories } = this.props;
		const { wizard } = this.state;
		const components = [];

		// eslint-disable-next-line
		for (const goodDeal of goodDeals) {
			const actions = [
				{
					color: "info",
					icon: "flag",
					tooltip: "Visualiser en anglais",
					href: getGoodDealUrl(goodDeal._id, "en"),
					onClick: () => {}
				},
				{
					color: "warning",
					icon: "visibility",
					tooltip: "Visualiser",
					href: getGoodDealUrl(goodDeal._id, "fr"),
					onClick: () => {}
				},
				...this.getActions(goodDeal.status)
			];
			components.push(
				<Grid item key={goodDeal._id} xs={12} md={4}>
					<MDBox pt={3} height="100%">
						<BookingCard
							image={goodDeal.photoUri}
							title={goodDeal.title}
							description={
								<MDBox minHeight="60px" sx={{ whiteSpace: "pre-wrap" }}>
									<LinesEllipsis
										text={goodDeal.description || ""}
										maxLine={3}
										trimRight
										basedOn="letters"
									/>
								</MDBox>
							}
							location={
								<MDTypography variant="button" fontWeight="medium">
									{goodDealsCategories[goodDeal.categoryId].name}
								</MDTypography>
							}
							price={this.renderStatus(goodDeal)}
							action={
								<MDBox>
									{actions.map(action =>
										this.renderActionButton(action, goodDeal._id)
									)}
								</MDBox>
							}
							disableHover={!!wizard}
						/>
					</MDBox>
				</Grid>
			);
		}
		return components;
	};

	delete = goodDealId => {
		this.setState({ goodDealToDelete: goodDealId });
	};

	changeCurrentPage = page => {
		const { fetchGetOwnGoodDeal, limit, sorted } = this.props;
		fetchGetOwnGoodDeal(page, limit, sorted);
	};

	renderAddButtons = toggleLabel => {
		const { modeTable } = this.state;
		return (
			<MDBox display="flex" flexWrap="wrap" justifyContent="flex-end" gap={1}>
				<MDButton
					variant="outlined"
					color="secondary"
					onClick={() => this.setState({ modeTable: !modeTable })}
				>
					<Icon>{modeTable ? "view_module" : "table_rows"}</Icon>
					&nbsp;{toggleLabel}
				</MDButton>
				<MDButton
					variant="gradient"
					color="primary"
					onClick={() => this.addWizard(false)}
				>
					<Icon>add</Icon>
					&nbsp;{"Ajout d'une annonce"}
				</MDButton>
			</MDBox>
		);
	};

	render() {
		const { color, message, wizard, modeTable, goodDealToDelete } = this.state;
		const {
			dispatch,
			page,
			totalPages,
			limit,
			sorted,
			areFetching,
			isFetchingList,
			fetchGetOwnGoodDeal
		} = this.props;

		return areFetching ? (
			<Activity />
		) : (
			<Grid container spacing={3}>
				{!modeTable && (
					<>
						{this.renderGoodDeals()}
						{!wizard && (
							<Grid item xs={12}>
								<MDBox
									display="flex"
									flexWrap="wrap"
									justifyContent="space-between"
									alignItems="center"
									gap={2}
								>
									<PagePagination
										currentPage={page}
										totalPages={totalPages}
										changeCurrentPage={this.changeCurrentPage}
									/>
									<MDBox ml="auto">{this.renderAddButtons("Tableau")}</MDBox>
								</MDBox>
							</Grid>
						)}
					</>
				)}
				{modeTable && (
					<Grid item xs={12}>
						<Card>
							<MDBox
								mx={2}
								mt={-3}
								py={2}
								px={2}
								variant="gradient"
								bgColor="primary"
								borderRadius="lg"
								coloredShadow="primary"
								display="flex"
								alignItems="center"
								color="white"
							>
								<Icon fontSize="medium">loyalty</Icon>
								<MDTypography variant="h6" color="white" ml={1.5}>
									Bons Plans
								</MDTypography>
							</MDBox>
							<MDBox p={2}>
								<DataTable
									data={this.getOwnGoodDealsData()}
									filterable
									columns={[
										{
											Header: "Date",
											accessor: "dateUpdated",
											sortable: true,
											filterable: false
										},
										{
											Header: "Titre",
											accessor: "title",
											sortable: true,
											filterable: false
										},
										{
											Header: "Catégorie",
											accessor: "category",
											sortable: false,
											filterable: false
										},
										{
											Header: "Expiration",
											accessor: "validationDate",
											sortable: true,
											filterable: false
										},
										{
											Header: "Statut",
											accessor: "status",
											sortable: true,
											filterable: false
										},
										{
											Header: "Actions",
											accessor: "actions",
											sortable: false,
											filterable: false
										}
									]}
									manual
									onFetchData={state => {
										dispatch({
											type: SET_GOODDEAL_SORTED,
											value: state.sorted
										});
										fetchGetOwnGoodDeal(
											state.page + 1,
											state.pageSize,
											state.sorted
										);
									}}
									loading={isFetchingList}
									defaultPageSize={limit}
									defaultSorted={sorted}
									page={page - 1}
									pageSizeOptions={[3, 6, 9, 18, 36, 72]}
									pages={totalPages}
									showPaginationTop
									showPaginationBottom={false}
									previousText="Précédent"
									nextText="Suivant"
									rowsText="Lignes"
									noDataText="Aucuns bons plans"
									ofText="sur"
									loadingText="Chargement..."
								/>
							</MDBox>
							{!wizard && (
								<MDBox p={2}>{this.renderAddButtons("Fiches")}</MDBox>
							)}
						</Card>
					</Grid>
				)}
				{wizard}
				<ConfirmDialog
					open={!!goodDealToDelete}
					message="Êtes-vous sûr de vouloir supprimer l'annonce ?"
					confirmText="Supprimer"
					onCancel={() => this.setState({ goodDealToDelete: null })}
					onConfirm={() => {
						this.deleteGoodDeal(goodDealToDelete);
						this.setState({ goodDealToDelete: null });
					}}
				/>
				<Notification
					place="br"
					color={color}
					message={message}
					open={this.state.br}
					onClose={this.hideAlert}
				/>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		_id,
		isFetching,
		isFetchingList,
		files,
		citiesIds,
		categoryId,
		description,
		phone,
		email,
		openingTime,
		price,
		address,
		zipCode,
		city,
		loc,
		webSiteUrl,
		fbUrl,
		title,
		promotion,
		lang,
		snackErrorMsg,
		snackInfoMsg,
		newWizard,
		photoUri,
		token,
		goodDeals,
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		channelsIds,
		templateId,
		choices,
		activityDescription,
		activityPostDescription,
		customUri,
		// Not named organizationScope: it would override the page prop
		organizationScope: scopedToOrganization
	} = state.gooddealReducer;

	const { isFetching: areFetching, user } = state.profileReducer;

	const { goodDealsCategories, campsites, organization } =
		state.entitiesReducer;
	return {
		scopedToOrganization,
		_id,
		areFetching,
		isFetching,
		isFetchingList,
		files,
		citiesIds,
		categoryId,
		description,
		phone,
		email,
		openingTime,
		price,
		address,
		zipCode,
		city,
		loc,
		webSiteUrl,
		fbUrl,
		title,
		promotion,
		lang,
		snackErrorMsg,
		snackInfoMsg,
		goodDealsCategories,
		newWizard,
		photoUri,
		campsites,
		token,
		goodDeals: Object.values(goodDeals),
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		user,
		organization,
		channelsIds,
		templateId,
		choices,
		activityDescription,
		activityPostDescription,
		customUri
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchPayGoodDeal,
			fetchGetOwnGoodDeal,
			fetchGetGoodDealDetails,
			fetchGetGoodDealChannels,
			fetchAddGoodDeal,
			fetchUpdateGoodDeal,
			fetchDeleteGoodDeal,
			fetchPublishGoodDeal,
			fetchModeratingAccept,
			fetchModeratingRefuse
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedGoodDealsWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(GoodDealsWizard);
const ConnectedPublishWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(PublishWizard);

const ConnectedGoodDealsPage = connect(
	mapStateToProps,
	mapDispatchToProps
)(GoodDealsPage);

// Good deals of the current organization: same constraints as its administrator
const GoodDealsOrganizationPage = props => (
	<ConnectedGoodDealsPage {...props} organizationScope />
);

export default {
	GoodDealsPage: ConnectedGoodDealsPage,
	GoodDealsOrganizationPage,
	GoodDealsWizard: ConnectedGoodDealsWizard,
	PublishWizard: ConnectedPublishWizard
};
